export default __webpack_public_path__ + "static/media/42t.27270623.jpg";